import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";

import { useDynamicFormsTranslate } from "@ryde/redux";
import {
  appLanguageSelector,
  ICustomField,
  INotificationDto,
  resolveNotificationContent,
} from "@ryde/shared";

import { GenericReadonly } from "../../common";

export const NotificationContentTemplate: FC<ICustomField> = ({
  name,
  formLabel,
}) => {
  const language = useRecoilValue(appLanguageSelector);
  const { control } = useFormContext();
  const { formLabelTranslated } = useDynamicFormsTranslate({
    name,
    fallbackText: formLabel,
  });
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, ...fieldRest }, fieldState: { error } }) => {
        value = value as INotificationDto["content"];
        return (
          <GenericReadonly
            label={formLabelTranslated}
            value={value ? resolveNotificationContent(value, language) : ""}
          />
        );
      }}
    />
  );
};
